import * as React from 'react'
import { Accordion, AccordionTitleProps } from 'semantic-ui-react'
import AccordionTitleContent from './AccordionTitleContent'
import AccordionContent from './AccordionContent'

import type { IntegrationTemplate } from '.'

type TemplateAccordionProps = {
  title: string
  connectorId: string
  connectorName: string
  isAuthenticated: boolean
  integrationTemplates: IntegrationTemplate[]
  activateIntegration: () => void
  deactivateIntegration: () => void
  deleteIntegration: () => void
  isActivating: boolean
}

export default function TemplateAccordion({
  title,
  integrationTemplates,
  connectorId,
  connectorName,
  activateIntegration,
  deactivateIntegration,
  deleteIntegration,
  isAuthenticated,
  isActivating,
}: TemplateAccordionProps) {
  // Controlled accordion so each panel's settings are fetched lazily, only once
  // expanded — Semantic UI mounts every panel's content on render, so an
  // uncontrolled accordion would fan out one settings request per template on
  // page load (the N+1 this fixes).
  const [activeIndices, setActiveIndices] = React.useState<number[]>([])

  function handleTitleClick(_event: React.MouseEvent, { index }: AccordionTitleProps) {
    const clickedIndex = Number(index)
    setActiveIndices((previous) =>
      previous.includes(clickedIndex)
        ? previous.filter((activeIndex) => activeIndex !== clickedIndex)
        : [...previous, clickedIndex]
    )
  }

  return (
    <>
      <p className="mt-6 font-bold">{title}</p>
      <Accordion
        fluid
        styled
        exclusive={false}
        activeIndex={activeIndices}
        onTitleClick={handleTitleClick}
        panels={integrationTemplates.map((template, index) => {
          return {
            key: template.template_id,
            title: {
              content: (
                <AccordionTitleContent title={template.name} isActive={template.is_active} />
              ),
            },
            content: {
              content: (
                <AccordionContent
                  template={template}
                  connectorId={connectorId}
                  connectorName={connectorName}
                  activateIntegration={activateIntegration}
                  deactivateIntegration={deactivateIntegration}
                  deleteIntegration={deleteIntegration}
                  isAuthenticated={isAuthenticated}
                  isActivating={isActivating}
                  isExpanded={activeIndices.includes(index)}
                />
              ),
            },
          }
        })}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/components/EmbeddingCyclrIntegration/TemplateAccordion.tsx